// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: 8REKzIRTXO
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import TextInput from "../../TextInput"; // plasmic-import: Z-JBWeJQzP-/component
import Button from "../../Button"; // plasmic-import: aLOScdJViiG/component

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicWaitlistForm.module.css"; // plasmic-import: 8REKzIRTXO/css

import Icon14Icon from "./icons/PlasmicIcon__Icon14"; // plasmic-import: UF_lLRFI-rKT/icon
import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: 074BTgmJsHD/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YgxDZcg-ug-/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: tWUxgGBbs9p/icon

export type PlasmicWaitlistForm__VariantMembers = {
  state: "success";
};

export type PlasmicWaitlistForm__VariantsArgs = {
  state?: SingleChoiceArg<"success">;
};

type VariantPropType = keyof PlasmicWaitlistForm__VariantsArgs;
export const PlasmicWaitlistForm__VariantProps = new Array<VariantPropType>(
  "state"
);

export type PlasmicWaitlistForm__ArgsType = {};
type ArgPropType = keyof PlasmicWaitlistForm__ArgsType;
export const PlasmicWaitlistForm__ArgProps = new Array<ArgPropType>();

export type PlasmicWaitlistForm__OverridesType = {
  root?: p.Flex<"div">;
  form?: p.Flex<"form">;
  button?: p.Flex<typeof Button>;
};

export interface DefaultWaitlistFormProps {
  state?: SingleChoiceArg<"success">;
  className?: string;
}

function PlasmicWaitlistForm__RenderFunc(props: {
  variants: PlasmicWaitlistForm__VariantsArgs;
  args: PlasmicWaitlistForm__ArgsType;
  overrides: PlasmicWaitlistForm__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root,
        { [sty.rootstate_success]: hasVariant(variants, "state", "success") }
      )}
    >
      <div
        className={classNames(projectcss.all, sty.freeBox__k3VXb, {
          [sty.freeBoxstate_success__k3VXbgXm3D]: hasVariant(
            variants,
            "state",
            "success"
          )
        })}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__ojB9S,
            {
              [sty.textstate_success__ojB9SgXm3D]: hasVariant(
                variants,
                "state",
                "success"
              )
            }
          )}
        >
          {"Get on the waitlist for the \nbeta release:"}
        </div>
      </div>

      {(hasVariant(variants, "state", "success") ? true : true) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__lgHvZ, {
            [sty.freeBoxstate_success__lgHvZgXm3D]: hasVariant(
              variants,
              "state",
              "success"
            )
          })}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__uAq0V, {
              [sty.freeBoxstate_success__uAq0VgXm3D]: hasVariant(
                variants,
                "state",
                "success"
              )
            })}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___04A88
              )}
            >
              {"Save&Share Files"}
            </div>

            <Icon14Icon
              className={classNames(projectcss.all, sty.svg__c2FYf)}
              role={"img"}
            />
          </div>

          <div className={classNames(projectcss.all, sty.freeBox__auNvi)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__sndYo
              )}
            >
              {"Save Comments"}
            </div>

            <Icon14Icon
              className={classNames(projectcss.all, sty.svg__tS5R)}
              role={"img"}
            />
          </div>

          <div className={classNames(projectcss.all, sty.freeBox__rcd3U)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__dmuMl
              )}
            >
              {"Share Comments With\nDirect Links"}
            </div>

            <Icon14Icon
              className={classNames(projectcss.all, sty.svg__xsyCp)}
              role={"img"}
            />
          </div>
        </div>
      ) : null}
      {(hasVariant(variants, "state", "success") ? true : true) ? (
        <form
          data-plasmic-name={"form"}
          data-plasmic-override={overrides.form}
          className={classNames(projectcss.all, sty.form, {
            [sty.formstate_success]: hasVariant(variants, "state", "success")
          })}
        >
          <div className={classNames(projectcss.all, sty.freeBox__zDrP)}>
            <TextInput
              aria-label={"name" as const}
              className={classNames("__wab_instance", sty.textInput__bNOA)}
              placeholder={"Your Name" as const}
              required={true}
            />
          </div>

          <div className={classNames(projectcss.all, sty.freeBox__gFRn)}>
            <TextInput
              aria-label={"profession" as const}
              className={classNames("__wab_instance", sty.textInput__bKXsD)}
              placeholder={"Your Profession" as const}
              required={true}
            />
          </div>

          <div className={classNames(projectcss.all, sty.freeBox___1108)}>
            <TextInput
              aria-label={"email" as const}
              className={classNames("__wab_instance", sty.textInput__gon6N)}
              placeholder={"Your Email" as const}
              required={true}
            />
          </div>

          <Button
            data-plasmic-name={"button"}
            data-plasmic-override={overrides.button}
            className={classNames("__wab_instance", sty.button)}
            color={"softGreen" as const}
            size={"compact" as const}
          >
            {"Submit"}
          </Button>
        </form>
      ) : null}
      {(hasVariant(variants, "state", "success") ? true : true) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox___7Ikz0, {
            [sty.freeBoxstate_success___7Ikz0GXm3D]: hasVariant(
              variants,
              "state",
              "success"
            )
          })}
        >
          {(hasVariant(variants, "state", "success") ? true : true) ? (
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__r2TBn,
                {
                  [sty.textstate_success__r2TBngXm3D]: hasVariant(
                    variants,
                    "state",
                    "success"
                  )
                }
              )}
            >
              {"You are on the list"}
            </div>
          ) : null}
          {(hasVariant(variants, "state", "success") ? true : true) ? (
            <Icon14Icon
              className={classNames(projectcss.all, sty.svg__m6QZr, {
                [sty.svgstate_success__m6QZRgXm3D]: hasVariant(
                  variants,
                  "state",
                  "success"
                )
              })}
              role={"img"}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "form", "button"],
  form: ["form", "button"],
  button: ["button"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  form: "form";
  button: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicWaitlistForm__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicWaitlistForm__VariantsArgs;
    args?: PlasmicWaitlistForm__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicWaitlistForm__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicWaitlistForm__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicWaitlistForm__ArgProps,
          internalVariantPropNames: PlasmicWaitlistForm__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicWaitlistForm__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicWaitlistForm";
  } else {
    func.displayName = `PlasmicWaitlistForm.${nodeName}`;
  }
  return func;
}

export const PlasmicWaitlistForm = Object.assign(
  // Top-level PlasmicWaitlistForm renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    form: makeNodeComponent("form"),
    button: makeNodeComponent("button"),

    // Metadata about props expected for PlasmicWaitlistForm
    internalVariantProps: PlasmicWaitlistForm__VariantProps,
    internalArgProps: PlasmicWaitlistForm__ArgProps
  }
);

export default PlasmicWaitlistForm;
/* prettier-ignore-end */
